// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import {Settings_context} from '../settings_ctx';
import {Link} from 'react-router-dom';
import {Editor} from '../../../shared/editor/editor';
import styles from './navigation_button.module.less';
import {use_screen} from '../lib/screen_util';

const get_rendered_navbar_img =()=>
    Array.from(document.querySelectorAll('.navbar_global_class img'))
      .find(img=>window.getComputedStyle(img.parentElement).display!='none');

interface i_back_button_props {
    button_title: string
    link: string;
    with_arrow_back?: boolean;
}

export const Navigation_button = ({button_title, link,
    with_arrow_back = false}: i_back_button_props)=>{
    const {theme} = useContext(Settings_context);
    const {width} = use_screen();
    const is_desktop = width > 1024;
    const [position, set_position] = useState(null);

    useEffect(()=>{
        if (is_desktop)
        {
            const TOP_FROM_LOGO = 86;
            const logo_el = get_rendered_navbar_img();
            const rect = logo_el.getBoundingClientRect();
            set_position({top: `${rect.top+TOP_FROM_LOGO}px`,
                left: `${rect.left}px`});
        }
    }, [is_desktop, width]);

    return <div className={styles.container} style={position}>
      <Link to={link}>
        <p className={theme.p3}>
          {with_arrow_back && <span>&lt;</span>}&nbsp;{button_title}</p>
      </Link>
    </div>;
};

interface i_plans_as_boxes_editor_props {
    value: i_back_button_props;
    on_change: (new_value: i_back_button_props)=>void;
}

export const Navigation_button_editor = ({value,
    on_change}: i_plans_as_boxes_editor_props)=>{
    return <Editor value={value} on_change={on_change}
      editors={[
        {key: 'button_title', label: 'Title', type: 'text'},
        {key: 'link', label: 'Link', type: 'text'},
        {key: 'with_arrow_back', label: 'Render back arrow', type: 'boolean'},
      ]}/>;
};
